import React from 'react';
import { MessageCircle } from 'lucide-react';
interface WhatsAppButtonProps {
  href: string;
  text: string;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function WhatsAppButton({
  href,
  text,
  variant = 'primary',
  className = ''
}: WhatsAppButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 hover:-translate-y-1 hover:shadow-lg';
  const variants = {
    primary: 'bg-whatsapp hover:bg-[#20ba5a]',
    secondary: 'bg-whatsappDark hover:bg-[#0f753e]'
  };
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-208">
      <MessageCircle className="w-5 h-5" data-id="element-209" />
      {text}
    </a>;
}